import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { ReviewSubmissionPanel } from './ReviewSubmissionPanel'

interface Props {
  request: InformalFeedbackRequest
}

export const ReviewSubmissionDrawer = observer(({ request, ...props }: DrawerProps & Props) => {
  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>Finish your review</Heading>
              </Drawer.Title>
              <Drawer.Close position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <ReviewSubmissionPanel />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
